import Vue from 'vue';
import Router from 'vue-router';

const TheContainer = () => import('@/components/TheContainer');
const Login = () => import('@/components/views/Login');
const Dashboard = () => import('@/components/views/Dashboard');
const Documentation = () => import('@/components/views/Documentation');
const Profile = () => import('@/components/views/Profile');
const Download = () => import('@/components/views/Download');


Vue.use(Router);
export default new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes(){
  return [
      {
      path: '/',
      component: TheContainer,
      children: [
        {
          path: '/',
          redirect: '/Dashboard',
          name: 'Navigation',
          component: {
            render (c) { return c('router-view')}
          },
          children: [
            {
              path: '/Dashboard',
              name: 'Dashboard',
              component: Dashboard
            },
            {
              path: '/Documentation',
              name: 'Documentation',
              component: Documentation
            }, 
            {
              path: '/Profile',
              name: 'Profile',
              component: Profile
            },
            {
              path: '/Download',
              name: 'Download',
              component: Download
            }
          ]
        },
      ]
    },
    {
    path: '/Login',
    component: Login,
    name: 'Login'
    }
  ]
}
